<template>
  <div class="term-content">
    <div class="section">
      <h1 class="subtitle">Declaração</h1>
      <p>
        Eu, aluno(a) acima identificado(a), declaro, para todos os fins, que solicitei minha inscrição no curso indicado e, neste ato, manifesto meu aceite expresso e irretratável quanto à reserva de vaga, à formação do vínculo comercial e acadêmico inicial, à análise documental, às condições financeiras ofertadas e às demais regras essenciais para a conclusão da matrícula acadêmica.
      </p>
    </div>

    <div class="section">
      <h1 class="subtitle">1. Objeto do aceite e formação do compromisso</h1>
      <p>
        Este termo tem por objeto registrar minha concordância com a reserva de vaga e com a formalização do meu compromisso de matrícula no curso indicado, autorizando a instituição a prosseguir com meu cadastro, organização de turma, planejamento pedagógico, separação da vaga e análise das informações e dos documentos por mim fornecidos.
      </p>
    </div>

    <div class="section">
      <h1 class="subtitle">2. Efeitos do aceite</h1>
      <p>
        Declaro estar ciente de que este aceite produz efeitos imediatos entre as partes, inclusive para fins de reserva de vaga, bloqueio de oportunidade comercial, parametrização financeira e início dos procedimentos internos de matrícula. A conclusão cadastral e acadêmica dependerá do cumprimento dos requisitos institucionais, mas o aceite ora prestado representa adesão do aluno às condições apresentadas pela instituição.
      </p>
    </div>

    <div class="section">
      <h1 class="subtitle">3. Documentos e veracidade das informações</h1>
      <p>
        Declaro que as informações prestadas são verdadeiras e assumo responsabilidade exclusiva por sua autenticidade, bem como pela entrega dos documentos exigidos pela instituição no prazo informado. Estou ciente de que documentos incompletos, ilegíveis, com divergência ou falsidade poderão impedir a conclusão da matrícula, suspender benefícios concedidos e ensejar cancelamento por iniciativa da instituição.
      </p>
    </div>

    <div class="section">
      <h1 class="subtitle">4. Condições financeiras iniciais</h1>
      <p>
        Declaro estar ciente de que valores, descontos, bolsas, campanhas, formas de pagamento, vencimentos, taxas e eventuais encargos serão considerados conforme a oferta vigente no momento do aceite e passarão a vincular minha adesão, salvo ajuste formal posterior realizado pela instituição. Benefícios condicionados poderão ser cancelados ou revistos caso os requisitos não sejam cumpridos.
      </p>
    </div>

    <div class="section">
      <h1 class="subtitle">5. Obrigação de comparecimento e continuidade</h1>
      <p>
        Declaro estar ciente de que, uma vez convocado(a) para as etapas seguintes de matrícula, deverei comparecer, concluir as exigências cadastrais e acadêmicas e observar frequência mínima, critérios de avaliação, calendário, reposições, atividades presenciais e/ou virtuais, estágios, práticas e demais regras pedagógicas previstas pela instituição.
      </p>
    </div>

    <div class="section">
      <h1 class="subtitle">6. Cancelamento, desistência e abandono</h1>
      <p>
        Estou ciente de que desistências, cancelamentos e ausência de comparecimento não produzem efeitos automáticos. Qualquer pedido de cancelamento deverá ser feito formalmente pelos canais definidos pela instituição, observadas as regras administrativas e financeiras aplicáveis. O simples abandono, silêncio ou não comparecimento não afastam, por si só, as obrigações assumidas neste aceite.
      </p>
    </div>

    <div class="section">
      <h1 class="subtitle">7. Proteção de dados e comunicações</h1>
      <p>
        Autorizo o tratamento dos meus dados pessoais para execução dos procedimentos de pré-matrícula, matrícula, atendimento acadêmico, contato comercial, contato financeiro e cumprimento de obrigações legais e regulatórias, nos termos da LGPD. Declaro, ainda, que os canais informados poderão ser utilizados para envio de avisos, orientações, boletos, notificações e demais comunicações relacionadas ao curso.
      </p>
    </div>

    <div class="section">
      <h1 class="subtitle">8. Reconhecimento de obrigação assumida</h1>
      <p>
        Declaro que li este termo integralmente, compreendi seu conteúdo e concordo com suas disposições, reconhecendo que este aceite eletrônico ou físico representa minha manifestação válida de vontade, com força de compromisso assumido perante a instituição para prosseguimento e conclusão da matrícula, nos limites aqui previstos.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DefaultTermComponent',
};
</script>

<style lang="scss" scoped>
  .term-content {
    overflow-y: auto;
    height: 55vh;

    .section {
      margin-top: 1rem;
      padding: 0 1rem;

      .subtitle {
        font-size: 16px;
        margin-bottom: 0.5rem;
      }

      p {
        text-align: justify;
        font-size: 12px;
        margin-bottom: 0.5rem;
      }
    }
  }
</style>
